"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputType = void 0;
var text_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/text_input_store"));
var checkbox_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/checkbox_input_store"));
var nested_single_select_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/nested_single_select_input_store"));
var photos_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/photos_input_store"));
var single_select_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/single_select_input_store"));
var watch_single_select_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/watch_single_select_input_store"));
var react_select_async_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/react_select_async_input_store"));
var hidden_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/hidden_input_store"));
var select_input_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/select_input"));
var radio_input_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/radio_input"));
var watch_select_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/watch_select"));
var InputType;
(function (InputType) {
    InputType["CHECKBOX"] = "checkbox";
    InputType["EMAIL"] = "email";
    InputType["NUMBER"] = "number";
    InputType["SELECT"] = "selectbox";
    InputType["NESTED_SELECT"] = "nested_selectbox";
    InputType["TEL"] = "tel";
    InputType["TEXT"] = "text";
    InputType["TEXTAREA"] = "textarea";
    InputType["REACT_SELECT"] = "react_select";
    InputType["TEXT_SUGGESTION"] = "text_suggestion";
    InputType["RADIO"] = "radio";
    InputType["PHOTOS"] = "photos";
    InputType["HIDDEN"] = "hidden";
    InputType["WATCH_SELECT"] = "watch_selectbox";
})(InputType = exports.InputType || (exports.InputType = {}));
// FIXME: いったん雰囲気で型キャストするけどちゃんと中身チェックして型キャストをする様にしたい
var InputStoreFactory = {
    createInputStore: function (props) {
        switch (props.type) {
            case InputType.TEXT:
            case InputType.EMAIL:
            case InputType.TEL:
            case InputType.NUMBER:
            case InputType.TEXTAREA:
                return new text_input_store_1.default(props);
            case InputType.CHECKBOX:
                return new checkbox_input_store_1.default(props);
            case InputType.NESTED_SELECT:
                return new nested_single_select_input_store_1.default(props);
            case InputType.WATCH_SELECT:
                return new watch_single_select_input_store_1.default(watch_select_1.default, props);
            case InputType.PHOTOS:
                return new photos_input_store_1.default(props);
            case InputType.RADIO:
                return new single_select_input_store_1.default(radio_input_1.default, props);
            case InputType.SELECT:
                return new single_select_input_store_1.default(select_input_1.default, props);
            case InputType.REACT_SELECT:
            case InputType.TEXT_SUGGESTION:
                return new react_select_async_input_store_1.default(props);
            case InputType.HIDDEN:
                return new hidden_input_store_1.default(props);
            default:
                throw new Error('Not Implemented');
        }
    }
};
exports.default = InputStoreFactory;
